import axios from "axios";

import { apiRoot } from "./services";

export class FileUpload {
    public scaleImages: boolean = false;
    // public files: File[] = [];
    public inputFiles: File[] = [];
    public value: null | any[] = null;
    public progress = 0.0;

    filesUploading = false;
    public get uploading() {
        return this.filesUploading;
    }

    async upload() {
        if (!this.inputFiles.length) {
            return;
        }

        this.filesUploading = true;

        const value = this.value || [];

        for (const file of this.inputFiles) {
            if (this.scaleImages && file.type.match(/image.*/)) {
                try {
                    value.push(await this.scaleAndUploadImage(file));
                } catch (e) {
                    // TODO
                    // logError(e);
                    value.push(await this.defaultUploadFile(file));
                }
            } else {
                value.push(await this.defaultUploadFile(file));
            }
        }

        this.inputFiles.splice(0, this.inputFiles.length);

        this.filesUploading = false;
        this.value = value;
    }

    remove(file: any) {
        const index = this.value!.indexOf(file);
        if (index === -1) {
            return;
        }

        this.value!.splice(index, 1);
    }

    async defaultUploadFile(file: File | Blob, fileName?: string): Promise<any> {
        const formData = new FormData();
        formData.append("file", file);

        const { data } = await axios.create({
            baseURL: apiRoot,
            onUploadProgress: (e) => {
                this.progress = e.loaded / e.total;
            }
        })
        .post("/_am_fileupload/Upload/Upload", formData, { transformResponse: (r) => r, responseType: "text" });

        const result = JSON.parse(data)[0];

        if (fileName) {
            result.DisplayName = fileName;
        }

        return result;
    }

    scaleAndUploadImage(file: File): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            const reader = new FileReader();

            reader.onerror = ev => {
                reject((ev.target as any).error);
            };

            reader.onload = () => {
                const image = new Image();

                image.onerror = (a, b, c, d, error) => {
                    reject(error);
                };

                image.onload = () => {
                    const canvas: HTMLCanvasElement = document.createElement("canvas");

                    const MAX_DIMENSION = 1024;

                    let width = image.width;
                    let height = image.height;

                    if (width > height && width > MAX_DIMENSION) {
                        height *= MAX_DIMENSION / width;
                        width = MAX_DIMENSION;
                    } else if (height > MAX_DIMENSION) {
                        width *= MAX_DIMENSION / height;
                        height = MAX_DIMENSION;
                    }

                    canvas.width = width;
                    canvas.height = height;

                    canvas.getContext("2d")!.drawImage(image, 0, 0, width, height);
                    canvas.toBlob((blob) => {
                        this.defaultUploadFile(blob!, file.name)
                            .then((s: string) => resolve(s))
                            .catch((e: Error) => reject(e));
                    }, "image/jpeg");
                };

                image.src = reader.result as string;
            };

            reader.readAsDataURL(file);
        });
    }
}
